module.exports = __webpack_public_path__ + "img/undraw_empty.4b1b5bf7.svg";